import { Action } from '@/_core/fluxstore/types';
import { StorymapState, ViewType } from '../types';
import { useStorymapStore } from '../useModule';
import { allCards, getCardById } from '../use';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class SelectCardForCopy extends Action<StorymapState> {
    public static ACTION_TYPE = 'SelectCardForCopy';

    public constructor(public cardId: string) {
        super(SelectCardForCopy.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState): Promise<boolean> => {
    if (state.currentViewType === ViewType.Tracking) {
        return false;
    }

    return true;
};

const reducer = (state: StorymapState, action: SelectCardForCopy): void => {
    const card = getCardById(action.cardId);
    allCards.value.forEach((x) => {
        x.isCopied = false;
        x.isCut = false;
    });
    card.isCopied = true;
};

//@ts-ignore
registerMiddleware(SelectCardForCopy.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SelectCardForCopy.ACTION_TYPE, reducer);
